import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { STEPS } from "@/lib/site";
import { CalendarClock, Car, Send } from "lucide-react";

const ICONS = [CalendarClock, Car, Send];

export default function HowItWorks() {
  useEffect(() => { document.title = "Nasıl Çalışır? | VoyaCar Rental"; }, []);
  return (
    <div>
      <div className="bg-[#171717] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold">Nasıl Çalışır?</h1>
          <p className="mt-2 text-neutral-300">3 basit adımda aracınızı kiralayın.</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div key={s.n} className="bg-white rounded-2xl border border-neutral-200 p-8 text-center" data-testid={`how-step-${s.n}`}>
                <div className="mx-auto h-16 w-16 rounded-2xl bg-[#FFF0F2] flex items-center justify-center mb-5"><Icon className="h-8 w-8 text-[#A11016]" /></div>
                <div className="text-sm font-bold text-[#A11016] mb-1">Adım {s.n}</div>
                <h3 className="text-lg font-semibold text-[#171717]">{s.title}</h3>
                <p className="mt-2 text-sm text-neutral-500">{s.text}</p>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-12">
          <Link to="/araclar"><Button className="h-12 px-8 bg-[#A11016] hover:bg-[#820D12] text-white font-semibold" data-testid="how-cta-button">Hemen Başla</Button></Link>
        </div>
      </div>
    </div>
  );
}
